import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { getToken } from 'src/mentor/services'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import FaqSection from '../PrewallAndPaywall/FaqSection'
import { FAQ_LAYOUTS } from '../PrewallAndPaywall/faqComponents/utils'
import { PublicAppFooter } from '../PublicAppFooter'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import UIScreenshotsDeaddictionPlan from './components/ActivityPlanScreenShotsCard/UIScreenshotsDeaddictionPlan'
import AddictionTypesCard from './components/AddictionTypesCard/AddictionTypesCard'
import BehavioralAnxietyPlansMainCard from './components/BehavioralAnxietyPlansMainCard/BehaviouralAnxietyPlansMainCard'
import EvidenceBasedPlans from './components/EvidenceBasedPlans/EvidenceBasedPlans'
import FourStepRecoveryPlan from './components/FourStepRecoveryPlan/FourStepRecoveryPlan'
import HowItWorks from './components/HowItWorks/HowItWorks'
import PersonSayingAQuoteCard, {
  PrimaryQuoteComponent,
} from './components/MentorQuoteCard/PersonSayingAQuoteCard'
import ReadyToTakeFirstStepCard from './components/ReadyToTakeFirstStepCard/ReadyToTakeFirstStepCard'

export const SOMYA_ADDICTION_EVENT_URL = '/mentor/somya/events/EVT-82c92c7fb0744a7ca63f7f0bd47195d9'

export default function BehavioralAddictionPlan() {
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  const showLoginButton = isTokenInvalidOrAbsent(getToken())

  const navigate = useNavigate()

  function showLoginPage() {
    setTypeOfClubbedAuthModal('login')
    setShowClubbedAuthModal(true)
  }

  function goToOnboarding(extraParams) {
    if (showLoginButton) {
      showLoginPage()
      return
    }
    navigate('addiction-selection')
  }

  return (
    <>
      <SEOComponent
        title={`Expert De-Addiction Self-Care Plans | Overcome Online Shopping, Smoking, Porn, Internet, Caffeine & Social Media Addictions | AUMHUM`}
        description={`Get personalized de-addiction self-care plans from expert psychologists. Our proven therapeutic approaches help you conquer online shopping addiction, smoking, porn, internet, caffeine, and social media scrolling addictions. Start your path to recovery today.`}
        image={getImageLink('MEDIA-ff3813e64efb4e41ac2b09af3165e9d4')}
        keywordsArr={['de-addiction', 'self-care plans', 'addiction recovery', 'expert psychologists', 'online shopping addiction', 'smoking cessation', 'porn addiction', 'internet addiction', 'caffeine addiction', 'social media addiction', 'therapeutic approaches', 'personalized de-addiction', 'addiction help', 'mental health support']}
      />
      <PublicAppHeader
        config={{ showLinks: true }}
        loginFunction={showLoginPage}
        registerFunction={() => {
          setTypeOfClubbedAuthModal('signup')
          setShowClubbedAuthModal(true)
        }}
      />
      <BehavioralAnxietyPlansMainCard
        buttonsOnClick={showLoginButton && showLoginPage}
        goToOnboarding={goToOnboarding}
      />
      <FourStepRecoveryPlan />
      <PersonSayingAQuoteCard
        primaryQuoteComponent={<PrimaryQuoteComponent />}
        primaryQuote="Have someone with you, who is 100% invested in your success"
        sideNote="My goal is too give you the support you need for the freedom from your addiction"
        personImage="MEDIA-b360b56d33754ea4b01717411225c332"
        personName="Somya Singh"
        personCreds="CLINICAL PSYCHOLOGIST"
        actionButtonData={{
          text: 'READY TO START YOUR JOURNEY?',
          onClick: () => {
            showLoginButton ? showLoginPage() : navigate(SOMYA_ADDICTION_EVENT_URL)
          },
        }}
      />
      <AddictionTypesCard />
      <HowItWorks buttonsOnClick={goToOnboarding} />
      <EvidenceBasedPlans buttonsOnClick={showLoginButton && showLoginPage} />
      <UIScreenshotsDeaddictionPlan buttonsOnClick={goToOnboarding} />
      <ReadyToTakeFirstStepCard buttonsOnClick={showLoginButton && showLoginPage} />
      <FaqSection
        categoryIds={[
          'faq-category-c423042cc36e435ead2d02bf87ecbef4',
          'faq-category-f1bcec23dd1d4812bfb45e9e75de6f5d',
          'faq-category-c487d0237e2f45be85518c31fae426f2',
          'faq-category-f73824c10cbf4fcab57c8cfe69afb5d1',
          'faq-category-f73824c10cbf4fcab57c8cfe69afb5d1',
          'faq-category-1b49444e348942f98982ffcdd47b8fd3',
          'faq-category-13c2bc55bf494dc88fc13499d787d485',
          'faq-category-dff689a90c55488e99321cf66d167188',
          'faq-category-1f599afcffca46ab8410ca199d0750ff',
        ]}
        scopeId={'behavioural-plans'}
        layoutType={FAQ_LAYOUTS.TWO_COLUMN_SIDEBAR}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
      <PublicAppFooter />
    </>
  )
}

/* <ImageAndTitleDescriptionVarThree
        image={'MEDIA-4a806eba76d24f689e64301d00b076b1'}
        title={'OUR PLANS ARE BACKED UP BY RESEARCH'}
        paragraphs={[
          'Use this space to communicate important messages with people within businesses and offices. It can contain short messages and announcements formatted according to a certain style that the company has determined.',
          'If you&apos;re writing your article, it&apos;s best to remember the purpose. It can be used to deliver information, make a request, respond to questions, propose solutions to problems, or present brief reports.',
          'A good guide is a simple three-part format: introduction, body, and conclusion. You can start by telling your audience what the article is about, then continue filling the next few paragraphs with your main thoughts. Summarize them, if needed, by the end of your message. Make sure the text is clear and easy to read. However, you can include a few relevant photos and captions. Another idea is to use your brand colors to align with your mission. Lastly, finalize your template so that it&apos;s ready to use anytime.',
        ]}
      /> */
